import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSwitcher.css';

function LanguageSwitcher({ id }) {
  const { i18n } = useTranslation();
  const [language, setLanguage] = useState(i18n.language);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng); 
    setLanguage(lng); 
  };

  useEffect(() => {
    setLanguage(i18n.language); 
  }, [i18n.language]);

  return (
    <div className="App">
      <div className="switch">
        <input
          type="checkbox"
          id={`language-toggle-${id}`}
          className="check-toggle check-toggle-round-flat"
          checked={language === 'en'} 
          onChange={() => changeLanguage(language === 'ka' ? 'en' : 'ka')} // ენების ლოგიკა შეიცვალა
        />
        <label htmlFor={`language-toggle-${id}`}></label>
        <span className="on">GEO</span> {/* ქართულს ვიყენებთ როგორც ძირითად */}
        <span className="off">ENG</span>
      </div>
    </div>
  );
}

export default LanguageSwitcher;
